"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.salesforceCampaigns = salesforceCampaigns;

var RequestState = _interopRequireWildcard(require("lead-flows-ui/utils/RequestState"));

var Actions = _interopRequireWildcard(require("lead-flows-ui/actions/SalesforceCampaigns"));

var INIT_STATE = {
  campaigns: [],
  sfdcSyncEnabled: false,
  requestState: RequestState.NOT_REQUESTED,
  requestStateSettings: RequestState.NOT_REQUESTED
};

function salesforceCampaigns() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Actions.REQUEST_CAMPAIGNS:
      return Object.assign({}, state, {
        requestState: RequestState.REQUEST_SUBMITTED
      });

    case Actions.SUCCEED_GETTING_CAMPAIGNS:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCESS
      });

    case Actions.RECEIVE_CAMPAIGNS:
      return Object.assign({}, state, {
        campaigns: action.campaigns
      });

    case Actions.FAIL_GETTING_CAMPAIGNS:
      return Object.assign({}, state, {
        requestState: RequestState.ERROR
      });

    case Actions.REQUEST_SFDC_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.REQUEST_SUBMITTED
      });

    case Actions.SUCCEED_GETTING_SFDC_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.SUCCESS
      });

    case Actions.RECEIVE_SFDC_SETTINGS:
      return Object.assign({}, state, {
        sfdcSyncEnabled: !!action.settings.syncEnabled
      });

    case Actions.FAIL_GETTING_SFDC_SETTINGS:
      return Object.assign({}, state, {
        requestStateSettings: RequestState.ERROR
      });

    default:
      return state;
  }
}